import { resolveAgentCompanyLogoUrl } from "./resolveAgentCompanyLogoUrl";

/**
 * Branding snapshot for public customer offer links (hotel / compare / organized).
 * @param {object|null|undefined} source agent row or getUserInfo() payload
 */
export function buildAgentPublicOfferBranding(source) {
  if (!source || typeof source !== "object") return null;
  const first = String(source.firstname || source.firstName || "").trim();
  const last = String(source.lastname || source.lastName || "").trim();
  const contactName = [first, last].filter(Boolean).join(" ").trim() || null;
  const branding = {
    logoUrl: resolveAgentCompanyLogoUrl(source),
    agencyName: String(source.companyname || source.companyName || "").trim() || null,
    agentName: contactName,
    phone: String(source.cell || source.phone || source.Phone || "").trim() || null,
    email: String(source.email || source.Email || "").trim() || null,
    whatsapp: String(source.whatsapp || source.WhatsApp || "").trim() || null,
  };
  return Object.values(branding).some(Boolean) ? branding : null;
}
